import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DatastoreService {
  permitQuestionsForm: any;
  permitData: any;
  paidAmount: number;
  purchase: any;
  bookings: any;
  selectedService: any;
  isInLocalArea: boolean;

  constructor() {}

  public config;

  public parentDepartment;

  public selectedDepartment;

  public bookingQuestions = [];

  public bookingForm;

  public selectedDate;

  public selectedSlot;

  public locations = [];

  public bookingAnswers;

  public customerDetailsForm;

  public client;

  public address;

  public latitude;

  public longitude;

  public endSlot;

  public customerQuestions;

  public address1;

  public registration: string;

  public banned: boolean;

  public observe: boolean;

  public wasteLimitAnswers: any[];

  public extra;

  public isRestrictedBooking;

  public isRestrictedAsbestosBooking;

  public restrictedAsbestosKey;

  public isCommercialBooking;

  public newRelic;

  notify: Subject<boolean> = new Subject<boolean>();
  onNotify(event) {
    this.notify.next(true);
  }
}
